// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"bcd80373","585":"bcd80373"}[chunkId] + ".chunk.css";
};